import React from 'react'
import List from './List'
import { usePositionCreatedUpdatedById } from 'src/queries'

interface BodyProps {
  id: number
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const position = usePositionCreatedUpdatedById(id)
  return (
    <List position={position} />
  )
}

export default Body
